module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }